<template>
  <div>
    <div class="grid_flex justify-space-between grid_mobile">
      <div class="d-flex">
        <div class="mr-2">ผู้จัดทำเอกสาร :</div>
        <div class="mr-2">{{ $props.user }}</div>
        <div>{{ $props.create_time }}</div>
      </div>
      <div class="d-flex">
        <div class="mr-2">สถานะ</div>
        <div v-if="$props.status === 0" style="color: #fdac39">กำลังดำเนินการ</div>
        <div v-else-if="$props.status === 1" style="color: #2d78ff">ส่งคืนแล้ว</div>
        <div v-else-if="$props.status === 2" style="color: #8cc63e">เสร็จสิ้น</div>
        <div v-else-if="$props.status === 3" style="color: #8cc63e">เสร็จสิ้น</div>
      </div>
    </div>
    <div class="grid_flex grid_mobile" v-if="update_user != null">
      <div class="d-flex">
        <div class="mr-2">อัพเดทเอกสารล่าสุด :</div>
        <div class="mr-2">{{ $props.update_user }}</div>
        <div>{{ $props.time_update }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "document_user",
  props: ['status', 'user', 'create_time', 'update_user', 'time_update']
}
</script>

<style scoped>
.grid_flex {
  display: flex;
}
@media only screen and (max-width: 680px) {
  .grid_mobile {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
